<app-navbar-style-one></app-navbar-style-one>

<div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>Offers </h2>
                    <p class="mt-4 mb-0 mx-3">Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/cart.png" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div>

<!-- that comes from home sub category icons that exists in the grid in home page -->
<!-- <section class="realMenuItems mt-4 mb-3">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <span class="currentRoute">{{'offers' | titlecase}}</span>
            </div>
            <div class="col-12 mt-5 items">
                <div class="row">
                    <div class="col-12 text-center">
                        <div class="spinner-grow" role="status" *ngIf="isLoading">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="!isLoading">
                        <div class="row">
                            <div class="col-lg-6 mt-3" *ngFor="let item of subCategoryProducts">
                                <div class="menu-container">
                                    <a (click)="toggleFav(item.id)" class="">
                                        <i class="bx bx-heart heart" [class.bxs-heart]="item.isFavorite" [class.bxs-heart.text-danger]="isFavorite(item.id)" [class.text-danger]="item.isFavorite"></i>
                                    </a>
                                    <img src="{{item.avatar}}" class="itemImage" width="200" height="200" alt="{{item.name}}">
                                    <div class="item-data">
                                        <h2>{{item.name}}</h2>
                                        <p class="itemDesc ellipsis">{{item.components}}</p>
                                        <span class="price" *ngIf="item.offer && item.show_price == 1; else noOffer">
                                            <span class="original-price" *ngIf="item.offer.type === 'percentage' || item.offer.type === 'discount'">
                                                {{item.types[0].price}} $
                                            </span>
                                            <span class="price text-danger">
                                                {{ calculateDiscountedPrice(item) }} $
                                            </span>
                                            <span class="offer-badge">
                                                {{ getOfferText(item.offer) }}
                                            </span>
                                        </span>
                                        <ng-template #noOffer>
                                            <span *ngIf="item.show_price == 1" class="price">{{item.types[0].price}} $</span>
                                        </ng-template>
                                        
                                        <span class="clear-both"></span>
                                    </div>
                                    <div class="row" style="align-items: end;">
                                        <div class="col-12">
                                            <button class="btn btn-primary" 
                                                data-bs-toggle="modal" 
                                                data-bs-target="#itemModalDetails" 
                                                (click)="selectProduct(item.id)">
                                                Order Now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="subCategoryProducts.length == 0">
                            <div class="alert alert-danger">
                                <strong>Oops!</strong> No Products Found
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- Offers Section -->
<section class="offers-section">
    <div class="container">
        <!-- Route Header -->
        <!-- <div class="row">
            <div class="col-12 text-center mb-4">
                <span class="currentRoute">{{'offers' | titlecase}}</span>
            </div>
        </div> -->

        <!-- Loading Spinner -->
        <div class="row" *ngIf="isLoading">
            <div class="col-12 text-center">
                <div class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>

        <!-- Products Grid -->
        <div *ngIf="!isLoading">
            <div class="offer-card" *ngFor="let item of subCategoryProducts">
                <div class="row g-0">
                    <div class="col-md-4">
                        <a class="h-100" href="product-details/{{item.id}}/{{item.name}}">
                            <img src="{{item.avatar}}" alt="{{item.name}}">
                        </a>
                        
                    </div>
                    <div class="col-md-8">
                        <div class="offer-content">
                            <a href="product-details/{{item.id}}/{{item.name}}">
                                <h3 class="offer-title">{{item.name}}</h3>
                            </a>
                            <p class="offer-description ">{{item.components}}</p>
                            
                            <!-- Price Section -->
                            <div class="price-section">
                                <span class="price" *ngIf="item.offer && item.show_price == 1; else noOffer">
                                    <!-- When offer exists -->
                                    <span class="old-price me-2" *ngIf="(item.offer.type === 'percentage' || item.offer.type === 'discount') && item?.types[0]">
                                        {{item?.types[0]?.price}} $
                                    </span>
                                    <span *ngIf="item?.types[0]" class="new-price text-danger">
                                        {{ calculateDiscountedPrice(item) }} $
                                    </span>
                                </span>
                                <span class="offer-badge">
                                    {{ getOfferText(item.offer) }}
                                </span>
                                <ng-template #noOffer>
                                    <span *ngIf="item.show_price == 1 && item?.types[0]" class="new-price">{{item.types[0].price}} $</span>
                                </ng-template>
                            </div>
                            
                            <div class="d-flex">
                                <!-- Favorite Button -->
                                <a (click)="toggleFav(item.id)" class="favorite-btn">
                                    <i class="bx bx-heart heart" 
                                    [class.bxs-heart]="item.isFavorite" 
                                    [class.bxs-heart.text-danger]="isFavorite(item.id)" 
                                    [class.text-danger]="item.isFavorite"></i>
                                </a>
                                <!-- Order Button -->
                                <a href="product-details/{{item.id}}/{{item.name}}" class="cart-btn"> <!--(click)="selectProduct(product.id)"-->
                                    <i class="bx bx-cart"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- No Products Message -->
            <div class="col-12 mt-3" *ngIf="subCategoryProducts.length == 0">
                <div class="alert alert-danger">
                    <strong>Oops!</strong> No Products Found
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Pagination Controls -->
<div class="col-12 mt-4" *ngIf="subCategoryProducts.length > 0 && totalPages > 1">
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="goToPage(currentPage - 1)" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      
      <li class="page-item" *ngFor="let page of getPagesArray()" 
          [class.active]="page === currentPage">
        <a class="page-link" (click)="goToPage(page)">{{page}}</a>
      </li>
      
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="goToPage(currentPage + 1)" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
  
  <div class="text-center text-muted mt-2">
    Showing page {{currentPage}} of {{totalPages}} ({{subCategoryProducts.length}} of {{totalItems}} items)
  </div>
</div>


<app-footer-style-two></app-footer-style-two>